import { PaymentRow } from '../services/billingApi';
import { formatBRL } from '../../../../utils/currencyUtils';

interface Props {
    payment: PaymentRow;
    invoices: any[];
}

const SelectedInvoicesSummary: React.FC<Props> = ({ payment, invoices }) => {
    const total = invoices.reduce((sum, inv) => sum + Number(inv.amountPaid || 0), 0);
    return (
        <>
            <p className="text-sm text-gray-700 dark:text-gray-200">
                Pagamento de <strong>{formatBRL(payment.amount || 0)}</strong>
                {payment.payer?.name && <> · {payment.payer.name}</>}
            </p>
            <ul className="text-sm text-gray-700 dark:text-gray-200 max-h-40 overflow-y-auto">
                {invoices.map(inv => (
                    <li key={inv.invoiceId}>
                        {inv.contractLabel && <>{inv.contractLabel} · </>}
                        {inv.details?.documentTitle || `fatura ${String(inv.invoiceId).slice(0, 8)}`}
                        {' · '}<strong>{formatBRL(inv.amountPaid || inv.amount || 0)}</strong>
                    </li>
                ))}
            </ul>
            {invoices.length > 1 && (
                <p className="text-sm text-gray-700 dark:text-gray-200">
                    Total: <strong>{formatBRL(total)}</strong>
                </p>
            )}
        </>
    );
};

export default SelectedInvoicesSummary;
